<template>
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 50px">
    <div style="width: 100%;">
      <div class="page-title-container">
        <p class="title-container">
          RIMOZIONE MASSIVA COLLI DA BANCALI
        </p>
      </div>
      <div class="table-container">
        <BulkRemoval/>
      </div>
    </div>
  </div>
</template>

<script>
import BulkRemoval from '../components/BulkRemoval.vue';

export default {
  name: "BulkRemovalView",
  components: {
    BulkRemoval,
  },
}
</script>

<style scoped>
.page-title-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-container {
  font-size: 2rem;
  letter-spacing: 2px;
}

.table-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
